const PeStepBar = ({ payload, xAxis, yAxis }) => {
  if (!payload?.startDate || !payload?.endDate) return null;
  if (!xAxis?.scale || !yAxis?.scale) return null;

  const x1 = xAxis.scale(payload.startDate);
  const x2 = xAxis.scale(payload.endDate);
  const y = yAxis.scale(payload.ttmEps);
  const y0 = yAxis.scale(0);

  return (
    <rect
      x={x1}
      y={y}
      width={Math.max(x2 - x1, 1)}
      height={y0 - y}
      fill="#60A5FA"
      fillOpacity={0.5}
    />
  );
};

export default PeStepBar;
